import { css } from "@emotion/react";

export const main = () => css`
  flex-grow: 1;
  padding-bottom: 5.5rem;
`;

export const page = css`
  display: flex;
  flex-direction: column;
`;
